import { ShowroomCoordinatesType } from '../../../types/showroom';

/* eslint-disable-next-line */

type ShowroomRadioButtonsProps = {
  activeShowroom: ShowroomCoordinatesType;
  coordinateDetails: ShowroomCoordinatesType[];
  onClick: (newCoordinates: ShowroomCoordinatesType) => void;
};

export function ShowroomRadioButtons(props: ShowroomRadioButtonsProps) {
  const { activeShowroom, coordinateDetails, onClick } = props;

  const radioButtons = coordinateDetails.map((showroom) => {
    const checked = showroom.locationName === activeShowroom.locationName;

    return (
      <div className="flex items-center" key={showroom.lat}>
        <input
          className="h-5 w-5"
          checked={checked}
          name="showroom"
          type="radio"
          value={showroom.locationName}
          onChange={() => onClick(showroom)}
        />
        <label
          className="font-MuseoSans100 font-extralight mr-4 pl-2"
          htmlFor={showroom.locationName}
        >
          {showroom.locationName}
        </label>
      </div>
    );
  });

  return (
    <div className="flex flex-col space-y-2 sm:space-y-0 sm:flex-row mt-8 mx-auto w-full max-w-defaultMax">
      {radioButtons}
    </div>
  );
}

export default ShowroomRadioButtons;
